import _ from 'lodash';

import state from './listingState';
import { getters, mutations, actions, FETCH_URL, RESET_FILTERS_URL } from './listing.js';
import LocalStorage from 'Core/commons/LocalStorage';

export default {
    namespaced: true,
    state() {
        return {
            ...state,
            funnel: {},
            ajaxStep: {},
            defaultFunnel: {},
        };
    },
    getters: {
        ...getters,

        funnelFilterValue: (state) => {
            if (state.filters.length == 0) {
                return '';
            }

            let filterFunnel = _.find(state.filters, { name: 'funnelid' });

            if (filterFunnel == undefined) {
                return '';
            }

            return filterFunnel.data.choice;
        },

        steps: (state) => {
            return state.funnel.steps;
        },

        totalOpp: (state) => {
            const stepsId = state.funnel.steps.map((step) => step.id);

            return Object.entries(state.pagination)
                .filter(([key, pagination]) => stepsId.includes(key))
                .reduce((count, [key, pagination]) => Number(count + pagination.total), 0);
        },

        defaultFunnel: (state) => state.defaultFunnel,
    },
    mutations: {
        ...mutations,

        updateKpis(state, payload) {
            Vue.set(state.kpis, payload.stepid, payload.kpis);
        },

        updateRows(state, payload) {
            if (state.pagination[payload.stepid].current_page == 1) {
                Vue.set(state.rows, payload.stepid, payload.rows);
            } else {
                Vue.set(state.rows, payload.stepid, [
                    ...state.rows[payload.stepid],
                    ...payload.rows,
                ]);
            }
        },

        setupPagination(state, payload) {
            Vue.set(state.pagination, payload.stepid, payload.pagination);
        },

        updateFunnel(state, funnel) {
            Vue.set(state, 'funnel', funnel);
            Vue.set(state.funnel, 'steps', funnel.steps ?? []);

            for (let step of state.funnel.steps) {
                Vue.set(state.rows, step.id, []);
                Vue.set(state.ajaxStep, step.id, false);
                Vue.set(state.pagination, step.id, {
                    current_page: 1,
                    per_page: 100,
                    last_page: '',
                    total: '',
                });
            }
        },

        updateStepPage(state, payload) {
            state.pagination[payload.stepid].current_page = payload.page;
        },

        updateStep(state, payload) {
            Vue.set(state.rows, payload.stepid, payload.rows);
        },

        setAjaxStep(state, payload) {
            Vue.set(state.ajaxStep, payload.stepid, payload.xhr);
        },

        setDefaultFunnel(state, funnel) {
            state.defaultFunnel = funnel;
        },
    },
    actions: {
        ...actions,

        init({ state, dispatch, commit }, props) {
            commit('init', props);
            dispatch('updateFunnelFilter', props.funnel);

            state.contextStorage = {};
        },

        fetch({ dispatch, getters, state, commit }, overwriteMeta) {
            if (!!state.ajax) {
                state.ajax.abort();
                commit('setAjax', false);
            }

            for (let stepid in state.ajaxStep) {
                if (state.ajaxStep[stepid] != false) {
                    commit('setAjaxStep', { stepid: stepid, xhr: false });
                }
            }

            dispatch('updateFunnel', getters.funnelFilterValue).then((response) => {
                for (let step of state.funnel.steps) {
                    let params = {
                        overwriteMeta: overwriteMeta,
                        forcecount: true,
                        step: step,
                        kpis: true,
                    };

                    if (state.init) {
                        params.init = state.init;
                    }

                    dispatch('fetchOne', params);
                }
            });
        },

        updateFunnel({ dispatch, getters, state, commit }, funnel) {
            return new Promise((resolve, reject) => {
                if (funnel == '' && funnel != state.funnel.id) {
                    resolve(false);
                    return;
                }

                axios
                    .get('/prospection/funnel/' + funnel)
                    .then((response) => {
                        dispatch('updateFunnelFilter', response.data);
                        resolve(response.data);
                    })
                    .catch((error) => reject(error));
            });
        },
        updateFunnelFilter({ state, commit }, funnel) {
            // if funnel is not object format compliant
            if (Array.isArray(funnel) && !funnel.length) {
                // define default funnel as current
                funnel = state.defaultFunnel;
                // find filter for funnelid
                let filter = state.filters.find((filter) => filter && filter.name == 'funnelid');
                if (undefined !== filter) {
                    // define value for filter
                    filter.data.choice = funnel.id; // id
                    commit('applyFilter', filter);
                    // inform user
                    Push.error(
                        window.i18n.__(
                            'Le filtre favori appliqué contient un pipeline supprimé, nous avons chargé le pipeline par défaut de votre compte',
                        ),
                    );
                }
            }

            commit('updateFunnel', funnel);
        },

        fetchOne({ dispatch, getters, state, commit }, payload) {
            let step = payload.step;

            var data = {
                meta: getters.meta,
                init: payload.init != undefined ? payload.init : false,
                forcecount: payload.forcecount != undefined ? payload.forcecount : false,
                kpis: payload.kpis ? payload.kpis : false,
                ...state.params,
            };

            // if (payload.overwriteMeta !== undefined) {
            //     data.meta = overwriteMeta;
            //     data.meta.pagination = { current_page: 1 };
            // }

            data.meta.pagination = state.pagination[step.id];
            data.meta.sorting = {
                field: 'rank',
                direction: 'desc',
            };

            if (data.meta.prefilter == undefined) {
                data.meta.prefilter = [];
            }
            data.meta.prefilter = {
                ...data.meta.prefilter,
                stepid: {
                    mode: 'is',
                    value: step.id,
                },
            };

            if (payload.init && state.favorite) {
                data.favorite = state.favorite;
            }

            return new Promise((resolve, reject) => {
                commit('setAjaxStep', {
                    stepid: step.id,
                    xhr: SellsyJS.WebServiceCaller.post(
                        `${FETCH_URL}/${state.listingname}`,
                        {},
                        data,
                        function (response) {
                            commit('setAjaxStep', {
                                stepid: step.id,
                                xhr: false,
                            });
                            if (response.error === undefined) {
                                dispatch('refreshData', {
                                    json: response,
                                    step: payload.step,
                                });
                                resolve(response);
                            } else {
                                reject;
                                commit('setError');
                            }
                        },
                        function (response) {
                            reject;
                            commit('setAjaxStep', {
                                stepid: step.id,
                                xhr: false,
                            });
                            commit('setError');
                        },
                    ),
                });
            });
        },

        refreshData({ dispatch, state, commit }, payload) {
            let data = payload.json != undefined ? payload.json : payload;
            let stepid = payload.step != undefined ? payload.step.id : 0;

            commit('setupPagination', {
                pagination: data.meta.pagination,
                stepid: stepid,
            });

            let stepFilterIndex = _.findIndex(data.meta.filters, { name: 'stepid' });

            if (stepFilterIndex != -1) {
                delete data.meta.filters[stepFilterIndex];
            }

            commit('updateFilters', data.meta.filters);

            if (getters.activeFilters(state).length) {
                commit('updateFiltersView', 'summary');
            }

            // delete data.meta.display.filters;
            commit('updateDisplay', data.meta.display);

            commit(
                'updateColumns',
                data.meta.columns.map((col) => {
                    col.display = true;
                    return col;
                }),
            );
            commit('updatePermissions', data.permissions);

            if (data.kpis) {
                commit('updateKpis', {
                    stepid: stepid,
                    kpis: data.kpis,
                });
            }

            if (state.init) {
                commit('flagInit');
            }

            commit('updateRows', {
                rows: Object.keys(data.data).length > 0 ? data.data : [],
                stepid: stepid,
            });

            dispatch('saveContext', stepid);
            EventBus.$emit('pipeline:endRefreshData');
        },

        updateStep({ dispatch, state, commit }, payload) {
            commit('updateStep', payload);
        },

        updateHeaderStep({ dispatch, state, commit }, payload) {
            commit('updateKpis', payload);
            commit('setupPagination', payload);
        },

        resetFilters({ dispatch, commit, getters, state }, apply = true) {
            for (const filter of getters.activeFilters) {
                if (filter.name != 'funnelid') {
                    commit('removeFilter', filter);
                }
            }
            for (const filter of getters.pendingFilters) {
                if (filter.name != 'funnelid') {
                    commit('removeFilter', filter);
                }
            }

            if (apply) {
                if (state.error) {
                    commit('deleteError');
                }

                commit(
                    'setAjax',
                    SellsyJS.WebServiceCaller.del(
                        `/listing/${state.listingname}/filters`,
                        {},
                        function (json) {
                            commit('setAjax', false);
                            if (json.error === undefined) {
                                commit('updateFilters', json.meta.filters);
                                dispatch('fetch');
                            } else {
                                commit('setError');
                            }
                        },
                        function () {
                            commit('setError');
                        },
                    ),
                );
            }
        },

        saveContext({ state, getters }, stepId) {
            //Init local storage for overview pagination
            if (!state.contextStorage[stepId]) {
                state.contextStorage[stepId] = new LocalStorage(
                    'listing_context',
                    state.listingname + '_' + stepId,
                );
            }

            let ids =
                state.rows[stepId].length !== undefined
                    ? state.rows[stepId].filter((row) => row.id !== undefined).map((row) => row.id)
                    : [];

            let meta = getters.meta;
            meta.pagination = state.pagination[stepId];
            meta.sorting = { field: 'rank', direction: 'desc' };
            meta.prefilter = meta.prefilter !== undefined ? meta.prefilter : [];
            meta.prefilter = {
                ...meta.prefilter,
                stepid: {
                    mode: 'is',
                    value: stepId,
                },
            };
            delete meta.columns;

            let pages = [];
            for (let i = meta.pagination.current_page; i > 0; i--) {
                pages.push(i);
            }

            state.contextStorage[stepId].set({
                meta: meta,
                ids: ids,
                pages: pages,
            });
        },
    },
};
